import React from "react";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { firestore, functions } from '../../helpers/Firebase';
import { NotificationManager } from "./react-notifications";
import { Colxx } from "./CustomBootstrap";

const UpdateNumberModal = ({ 
  selected,
  isOpen, 
  toggle, 
  changeNumber, 
  setChangeNumber, 
  updatedProvider,
  onNumberUpdated 
}) => {
  const createNotification = (className, error) => {
    let cName = className || "";
    return (
      NotificationManager.error(
        error,
        "Error",
        2000,
        null,
        cName
      )
    )
  };

  const handleNumberChange = () => {
    const changeProviderNumber = functions().httpsCallable('updateRecords');
    changeProviderNumber({ 
      uid: updatedProvider?.key, 
      prop: { phoneNumber: changeNumber.value, country_code: changeNumber.country_code, number: changeNumber.number } 
    }).then(function (result) {
      if (!result?.data?.error) {
        firestore().collection(selected).doc(updatedProvider?.key).update({
          number: changeNumber.number,
          country_code: changeNumber.country_code,
          phoneNumber: changeNumber.value,
          updated: Date.now()
        }).then(() => {
          if (onNumberUpdated) {
            onNumberUpdated(changeNumber.value, changeNumber.country_code, changeNumber.number);
          }
          toggle(false);
        });
      } else {
        createNotification("error", result?.data?.error?.errorInfo?.message);
      }
    });
  };

  return (
    <Modal isOpen={isOpen} backdrop="static">
      <ModalHeader>
        Change Phone Number
      </ModalHeader>
      <ModalBody>
        <Row>
          <Colxx xxs="12">
            <Label>
              Phone Number
            </Label>
            <PhoneInput
              regions={['middle-east', 'north-africa']}
              inputStyle={{ width: '100%', height: '42px', border: '1px solid #d7d7d7' }}
              className="customInput"
              country={'ae'}
              placeholder="e.g. +971xxxxxx"
              value={changeNumber.value || ''}
              onChange={(value, data, event, formattedValue) =>
                setChangeNumber({ ...changeNumber, value: formattedValue , country_code: data.dialCode, number: value.slice(data.dialCode.length)})
              }
            />
          </Colxx>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" outline onClick={() => toggle(false)}>
          Cancel
        </Button>
        <Button color="primary" className="top-right-button" onClick={handleNumberChange}>
          Change
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateNumberModal;
